import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "../sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/features/store/store";
import { openSideBar } from "../../../../app/features/sidebar/sidebarSlice";

const HeaderWithSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const globalOpen = useSelector((state: RootState) => state.sideBar.isOpen);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(openSideBar());
  };

  const handleDrawerOpen = () => {
    setIsOpen(true);
    toggleDrawer(true);
    handleClick();
  };

  const handleDrawerClose = () => {
    setIsOpen(false);
    toggleDrawer(true);
    handleClick();
  };

  const toggleDrawer =
    (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setIsOpen(isOpen);
    };

  return (
    <>
      <Header handleDrawerOpen={handleDrawerOpen} />
      <Sidebar
        isOpen={isOpen || globalOpen}
        handleDrawerClose={handleDrawerClose}
        handleDrawerOpen={handleDrawerOpen}
      />
    </>
  );
};

export default HeaderWithSidebar;
